var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('v-card-actions',{staticClass:"clickable pa-0"},[_c('div',{staticClass:"pl-2"},[_vm._v(" "+_vm._s(_vm.totalCount)+" "),_c('span',[_vm._v(_vm._s(_vm.totalCount == 1 ? _vm.$t('message.reaction') : _vm.$t('message.reactions')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }